<template>
  <div>
    <div v-for="cartItem in list">
      <swipeout style="background-color: #FFFFFF">
        <swipeout-item class="pb-1" @on-close="handleEvents('on-close')" transition-mode="follow">
          <div slot="right-menu">
            <swipeout-button @click.native="deleteItem(cartItem)" type="warn">{{$t('general.CURD.delete')}}</swipeout-button>
          </div>
          <div slot="content" class="demo-content vux-1px-t" >
            <CartItem :title="cartItem.nameHk" :currency="$t('kol.priceUnit')" :price="cartItem.unitPrice" :image="cartItem.imageMain" :quantity="cartItem.quantity" :products="cartItem"></CartItem>
          </div>
        </swipeout-item>
      </swipeout>
    </div>
  </div>
</template>
<script type="text/javascript">

import { mapGetters } from 'vuex'
import CartItem from './CartItem'
import { Swipeout, SwipeoutItem, SwipeoutButton } from 'vux'

export default {
  name: 'CartList',
  components: {
    CartItem,
    Swipeout, 
    SwipeoutItem, 
    SwipeoutButton
  },
  props: {
    list: Array,
    currency: String
  },
  data() {
    return {

    }
  },
  created() {
  },
  mounted() {},
  watch: {},
  computed: {

  },
  methods: {
    deleteItem (product) {
      // this.$store.commit('removeCartProduct', productID);
      this.$store.dispatch('removeCartProduct',product);
    },
    handleEvents (type) {
      console.log('event: ', type)
    }
  },
}

</script>
<style type="text/css">

</style>




// WEBPACK FOOTER //
// src/Cart/components/CartList.vue